import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import { ReactComponent as ChevronDownIcon } from '@lifesize/ux-assets/vectors/svgIcons/chevron-down.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import SearchDropdownComp from 'components/SearchDropdown/SearchDropdown';
import ModeratorSearchBar from 'components/ModeratorSearch/ModeratorSearchBar';
import ModeratorSearchResults from 'components/ModeratorSearch/ModeratorSearchResults';
import classes from 'components/ModalInput/ModalInput.module.scss';

class ModeratorSearch extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      blurred: false
    };
  }

  componentDidMount() {
    this.props.handleResetContact();
    if (Object.keys(this.props.input.value).length) {
      this.props.handleSelectContact(this.props.input.value);
    } else if (this.props.isCreate) {
      this.props.handleSelectContact(this.props.selfResult);
      this.props.input.onChange(this.props.selfResult);
    }
  }

  handleSelectContact = (contact) => {
    this.props.handleSelectContact(contact);
    this.props.input.onChange(contact);
  };

  blurInput = () => {
    this.setState({ blurred: !this.state.blurred });
  };

  render() {
    const moderatorFieldsetClass = _compact([
      this.props.boxType ? classes.boxInput : classes.modalInputFieldset,
      classes.isDropdown
    ]).join(' ');

    let tooltipShift;
    let tooltipTextAlign;
    let tooltipWidth;

    switch (this.props.tooltipPosition) {
      case 'top':
        tooltipShift = 'right';
        tooltipTextAlign = 'right';
        tooltipWidth = '285px';
        break;
      default:
        tooltipTextAlign = 'left';
        tooltipWidth = '170px';
    }

    return (
      <fieldset className={moderatorFieldsetClass}>
        <SearchDropdownComp
          buttonComponent={
            <ModeratorSearchBar {...this.props} blurInput={this.blurInput} blurred={this.state.blurred}>
              <Tooltip
                label={
                  <FormattedMessage
                    id="components.moderatorSearch.tooltip"
                    defaultMessage="Moderators can mute and unmute participants, and remove them from meetings."
                  />
                }
                location={this.props.tooltipPosition}
                shift={tooltipShift}
                style={{
                  textAlign: tooltipTextAlign,
                  whiteSpace: 'normal',
                  width: tooltipWidth
                }}
              />
            </ModeratorSearchBar>
          }
          clickOutsideHandler={this.props.handleSetIsFocused}
          isVisible={this.props.isFocused}
          itemHeight={42}
          maxItems={this.props.maxItems}
          menuComponent={
            <ModeratorSearchResults
              {...this.props}
              blurInput={this.blurInput}
              handleSelectContact={this.handleSelectContact}
            />
          }
        />
        {!this.props.boxType && <ChevronDownIcon data-testid="chevronDownIcon" className={classes.dropdownIndicator} />}
      </fieldset>
    );
  }
}

ModeratorSearch.propTypes = {
  boxType: PT.bool,
  handleResetContact: PT.func,
  handleSelectContact: PT.func,
  handleSetIsFocused: PT.func.isRequired,
  input: PT.object,
  isCreate: PT.bool,
  isFocused: PT.bool.isRequired,
  maxItems: PT.number.isRequired,
  passedName: PT.string,
  required: PT.bool,
  selfResult: PT.object,
  tooltipPosition: PT.string
};

ModeratorSearch.defaultProps = {
  tooltipPosition: 'right'
};

export default ModeratorSearch;
